<div *ngIf="isAccessible">
  <loader [show]="isLoading"></loader>
  <div *ngIf="viewModel" body>
    <button actionButton class="btn btn-complete"
            (click)="printAllDocumentsAsync()">{{'Screens.LastAttachments.Actions.Print' | translate}}</button>
    <div class="row" *ngFor="let pair of docTypePairs">
      <div *ngFor="let adpt of pair" class="col-md-6 doc-type-col">
        <ng-container *ngIf="!adpt.isPlaceHolder">
          <ng-container *ngIf="adpt.isMedicalReport; else otherDoc">
            <div class="doc-type">
              <div class="section type">
                Medical Report
              </div>
              <div class="section details">
                <div *ngIf="adpt.medicalReport">
                  {{'Screens.LastAttachments.Labels.Updated' | translate }}:
                  {{adpt.medicalReport.lastModified | wafShortDate}}
                </div>
              </div>
              <div class="section actions">
                <div class="action" (click)="openMedicalReport($event)"
                     *ngIf="(currentPermissions.medicalReports.canEdit || adpt.medicalReport) && !(patientInactive && !adpt.medicalReport && currentPermissions.medicalReports.canEdit)">
                  {{'Common.SearchActionsAndDetailsActions.'
                  + (
                  currentPermissions.medicalReports.canEdit ? (adpt.medicalReport ? 'Edit' : 'Add') : 'Open'
                  ) | translate }} <i class="fa fa-caret-right"></i>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #otherDoc>
            <div class="doc-type">
              <div class="section type"
                   [class.required-mark]="lastAttachmentSource == lastAttachmentSourceEnum.SaleOrder && adpt.docType.isRequiredInSaleOrder">
                {{adpt.docType.name}}
              </div>
              <div class="section details">
                <div *ngIf="adpt.docType.lastAttachedDocument">
                  <div class="file-link">
                    <div (click)="onAttachmentClick($event, adpt.docType.lastAttachedDocument)"
                         class="file-link-wrapper">
                      {{adpt.docType.lastAttachedDocument.name}}
                    </div>
                  </div>
                  <div>
                    {{'Screens.LastAttachments.Labels.Uploaded' | translate }}:
                    {{adpt.docType.lastAttachedDocument.date | wafShortDate}}
                  </div>
                  <div *ngIf="adpt.docType.lastAttachedDocument.appointmentType">
                    ({{adpt.docType.lastAttachedDocument.appointmentType}} appointment)
                  </div>
                </div>
              </div>
              <div *ngIf="!adpt.isFittingReport; else fittingReportBlock"
                   [class.draggable]="currentPermissions.documents.canEdit && !patientInactive"
                   class="section actions">
                <ng-container *ngIf="currentPermissions.documents.canEdit && !patientInactive">
                  <label>
                    
                    <div *ngIf="adpt.docType.lastAttachedDocument" class="action-title">
                      {{'Screens.LastAttachments.Actions.Change' | translate}}
                      <i class="fa fa-caret-right"></i>
                    </div>
                    <div *ngIf="!adpt.docType.lastAttachedDocument" class="action-title upload-title">
                      {{'Screens.LastAttachments.Actions.Upload' | translate}}
                    </div>

                    <div (click)="onGeneratePatientForm(adpt.docType.id); false;" class="action-title generate" *ngIf="adpt.docType.generatable">
                      {{ 'Screens.LastAttachments.Actions.Generate' | translate }}
                      <i class="fa fa-caret-right"></i>
                    </div>

                    <div class="drag-and-drop-tip">
                      You can drag file here
                    </div>

                    <input class="fileChange" (change)="onFileChange($event, adpt.docType)" type="file" />
                  </label>
                </ng-container>
              </div>
              <ng-template #fittingReportBlock>
                <div class="section actions">
                  <label
                         *ngIf="currentPermissions.fittingReport.canEdit || adpt.docType.lastAttachedDocument"
                         (click)="openFittingReport(adpt.docType.fittingReport2Id)">
                    {{
                    (
                    currentPermissions.fittingReport.canEdit && !patientInactive ?
                    (
                    adpt.docType.lastAttachedDocument ?
                    'Screens.LastAttachments.Actions.Edit' :
                    'Screens.LastAttachments.Actions.Generate'
                    ) : 'Common.SearchActionsAndDetailsActions.Open'
                    ) | translate
                    }} <i class="fa fa-caret-right"></i>
                  </label>
                </div>
              </ng-template>
            </div>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #documentGenerationConfirmation let-data="data" let-modal="modal">
  <div class="col-sm-12 generated-doc-message">
    <div>{{ 'Screens.LastAttachments.Messages.DocumentWasGeneratedAndAddedToThePatientDocs' | translate }}</div>
    <div>
      <span (click)="modal.close(true)"
            class="file-link">{{'Messages.MessageHeadersAndActions.Download' | translate}}</span>
    </div>
  </div>
</ng-template>